<div class="row row-flex cj-reduction-logo" id="upaLogin">
  <div class="cj-landing-header">
    <div class="cj-header-logo">
      <a class="cj-logo" href="https://www.rastreator.com" target="_blank" title="Go to Rastreator website">
        <img class="hidden-xs" src="{{ baseImageUrl }}shared/rastreator.svg" alt="Rastreator.com" />
        <img class="visible-xs" src="{{ baseImageUrl }}shared/logo-icon-rastreator.svg" alt="Rastreator.com" />
      </a>
    </div>
    <div class="header-right-section">
      <div class="user-login" id="userLogin"></div>
    </div>
  </div>
</div>
